<script>
	import { focusTrap } from '$lib/focusTrap';
	import AppOverlay from '$lib/elements/appOverlay.svelte';
	import { confirm, disableBtns } from '$lib/stores';
	import { fade } from 'svelte/transition';
	import { _ } from 'svelte-i18n';
	import Button from '$lib/elements/button.svelte';

	let text = $confirm.text;
	let btnOk = $confirm.okText;
	let btnCancel = $confirm.cancelText;
	let okAction = $confirm.action;
	let wrap = $confirm.wrap;
	let app = $confirm.app;
</script>

{#if app}
	<AppOverlay small>
		<div role="alertdialog" aria-labelledby="confirm-text" aria-modal="true">
			<div class="mb-8">
				<img src="/icons/error-icon-white.svg" alt="" class="w-10 mx-auto mb-6" />
				<p id="confirm-text" class="read leading-tight text-xl text-center">{text}</p>
			</div>
			<div class="button-row flex justify-around my-4" tabindex="-1">
				<div>
					<span id="btnCancelLabel" class="read label !p-0 text-center">{btnCancel}</span>
					<div class="w-14 h-14 mt-1">
						<Button
							audioButton
							aria-labelledby="btnCancelLabel"
							secondary
							icon="/icons/button-cancel-icon.svg"
							id="btnCancel"
							height="100%"
							larger
							on:click={() => {
								$confirm.active = false;
								$disableBtns = false;
							}}
						/>
					</div>
				</div>
				<div>
					<span id="btnOkLabel" class="read label !p-0 text-center">{btnOk}</span>
					<div class="w-14 h-14 mt-1">
						<Button
							audioButton
							aria-labelledby="btnOkLabel"
							icon="/icons/button-check-icon.svg"
							id="btnOk"
							height="100%"
							larger
							on:click={() => {
								okAction();
								$confirm.active = false;
							}}
						/>
					</div>
				</div>
			</div>
		</div>
	</AppOverlay>
{:else}
	<div
		use:focusTrap
		transition:fade|global={{ duration: 200 }}
		class="modal-wrap fixed z-[100] inset-y-0 inset-x-0 py-8 px-3"
	>
		<div
			class="confirm-modal w-[480px] max-w-full mx-auto mt-[10%] p-8 border-4 border-theme_amber rounded-lg bg-theme_white text-theme_black"
			role="alertdialog"
			aria-labelledby="confirm-text"
			aria-modal="true"
		>
			<div class="flex gap-6 items-center flex-col xs:flex-row">
				<img src="/icons/error-icon.svg" alt="" class="w-10 flex-shrink-0 mx-auto" />
				<p id="confirm-text" class="leading-tight mt-[3px] text-xl flex-grow">{@html text}</p>
			</div>
			<div
				class="button-row flex gap-4 mt-12 flex-col xs:flex-row {wrap ? 'flex-wrap' : ''}"
				tabindex="-1"
			>
				<Button
					text={btnCancel}
					on:click={() => {
						$confirm.active = false;
					}}
					icon="/icons/cancel-icon.svg"
					secondary
				/>
				<Button
					text={btnOk}
					on:click={() => {
						okAction();
						$confirm.active = false;
					}}
				/>
			</div>
		</div>
	</div>
{/if}

<style>
	.modal-wrap {
		background-color: rgba(0, 0, 0, 0.5);
	}
</style>
